import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Components/Layout';

export default function PaymentSuccessful() {
    const navigate = useNavigate();
    const location = useLocation(); 
    const id = location.state?.id;

    React.useEffect(() => {
        if (!id) {
            navigate('/');
        }
    }, [id, navigate]);

    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-02 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">Payment Successful</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item">
                                        <button 
                                            onClick={() => navigate('/')} 
                                            className="btn btn-link text-decoration-none p-0"
                                        >
                                            <i className="isax isax-home5 me-1"></i>
                                            Home
                                        </button>
                                    </li>
                                    <li className="breadcrumb-item">Payment</li>
                                    <li className="breadcrumb-item active" aria-current="page">Success</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8 col-md-10">
                            <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                                <div className="card-body p-4 p-lg-5">
                                    <div className="text-center">
                                        <div className="success-animation mb-4">
                                            <img 
                                                src="/assets/img/payment-success.png" 
                                                className="img-fluid mb-4"
                                                style={{ 
                                                    maxWidth: '180px',
                                                    animation: 'bounceIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                                                }} 
                                                alt="Payment Success" 
                                            />
                                        </div>
                                        <div className="success-content">
                                            <h2 className="h3 text-success mb-3">
                                                Payment Successful 🎉
                                            </h2>
                                            <p className="text-muted mb-4">
                                                Great news! Your payment has been successfully processed. 
                                                You can now view your booking details or return to the homepage.
                                            </p>
                                            
                                            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                                                <button 
                                                    onClick={() => navigate('/dashboard-bookings-detail', {state: {id: id}})} 
                                                    type="button" 
                                                    className="btn btn-primary btn-lg px-4 gap-3"
                                                >
                                                    <i className="fas fa-file-alt me-2"></i>
                                                    View Booking Details
                                                </button>
                                                <button 
                                                    onClick={() => navigate('/')} 
                                                    type="button" 
                                                    className="btn btn-outline-secondary btn-lg px-4"
                                                >
                                                    <i className="fas fa-home me-2"></i>
                                                    Back to Home
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>
                {`
                    .success-animation img {
                        transition: transform 0.3s ease;
                    }
                    
                    .success-animation img:hover {
                        transform: scale(1.05);
                    }
                    
                    @keyframes bounceIn {
                        0% {
                            opacity: 0;
                            transform: scale(0.3);
                        }
                        50% {
                            opacity: 0.9;
                            transform: scale(1.1);
                        }
                        80% {
                            opacity: 1;
                            transform: scale(0.89);
                        }
                        100% {
                            opacity: 1;
                            transform: scale(1);
                        }
                    }

                    /* Responsive adjustments */
                    @media (max-width: 576px) {
                        .card-body {
                            padding: 1.5rem !important;
                        }
                        
                        .btn-lg {
                            width: 100%;
                            margin-bottom: 0.5rem;
                        }

                        .success-animation img {
                            max-width: 150px !important;
                        }
                    }

                    /* Button hover effects */
                    .btn-primary:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        transition: all 0.3s ease;
                    }

                    .btn-outline-secondary:hover {
                        background-color: #f8f9fa;
                        transform: translateY(-2px);
                        transition: all 0.3s ease;
                    }
                `}
            </style>
        </Layout>
    );
}
